module.exports = __webpack_public_path__ + "img/9791185751665.7f3c8731.jpg";